import { FC } from 'react';

import { EntityApprovalStatus } from '@/api/entity/types';
import { FundApprovalStatus } from '@/api/fund/types';
import AlertIcon from '@/assets/svg/ui-elements/alert-triangle-outline-gray.svg';
import { Tooltip } from '@/design-system';
import { FUND_SUSPENSION_TOOLTIP, isFundSuspended } from '@/utils/fund-suspension';

interface Props {
  fundApprovalStatus?: FundApprovalStatus | null;
  entityApprovalStatus?: EntityApprovalStatus | null;
  size?: number;
}

/**
 * Alert icon + tooltip shown next to the status tag when a Fund is suspended —
 * either by its own status (Re-verification Pending / Rejected / Blocked) or
 * because its parent entity is pending or closed. Renders nothing otherwise.
 */
export const SuspendedFundAlert: FC<Props> = ({
  fundApprovalStatus,
  entityApprovalStatus,
  size = 16,
}) => {
  if (!isFundSuspended(fundApprovalStatus, entityApprovalStatus)) return null;

  return (
    <Tooltip title={FUND_SUSPENSION_TOOLTIP} side="top">
      <span style={{ display: 'inline-flex', alignItems: 'center', flexShrink: 0 }}>
        <AlertIcon width={size} height={size} />
      </span>
    </Tooltip>
  );
};
